<template>
  <v-btn @click="addBulk">ADD BULK</v-btn>
</template>
<script>
import slugify from "slugify";
import * as moment from "moment";
import firebase from "firebase";

export default {
  data: () => ({
    users: [
      {
        "File No.": "53000-0001",
        "Last Name": "Behr",
        Name: "Doug",
        Dependant: "",
        Street: "13694 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 570,
        "Primary Phone": "818-795-1100",
        "Secondary Phone": "",
        "Primary Email": "malebehr@earthlink.net",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0002",
        "Last Name": "Bresnan",
        Name: "Jerry",
        Dependant: "",
        Street: "13697 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 640,
        "Primary Phone": "818-336-6927",
        "Secondary Phone": "",
        "Primary Email": "jerryb334@aol.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0002",
        "Last Name": "Bresnan",
        Name: "Kathy",
        Dependant: "",
        Street: "13697 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 640,
        "Primary Phone": "760-685-1314",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0003",
        "Last Name": "Valenciana",
        Name: "Edgar",
        Dependant: "",
        Street: "13758 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 472,
        "Primary Phone": "909-630-8593",
        "Secondary Phone": "",
        "Primary Email": "efvalenciana@yahoo.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0004",
        "Last Name": "Smith",
        Name: "Jeff",
        Dependant: "",
        Street: "13753 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 526,
        "Primary Phone": "818-404-2801",
        "Secondary Phone": "",
        "Primary Email": "5252jsmith@gmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0004",
        "Last Name": "Smith",
        Name: "Adriene",
        Dependant: "",
        Street: "13753 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 526,
        "Primary Phone": "310-259-1773",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0005",
        "Last Name": "Hernandez",
        Name: "Javier",
        Dependant: "",
        Street: "13723 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 603,
        "Primary Phone": "818-485-9294",
        "Secondary Phone": "",
        "Primary Email": "javiercanek@ca.rr.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0005",
        "Last Name": "Hernandez",
        Name: "Maria",
        Dependant: "",
        Street: "13723 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 603,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0006",
        "Last Name": "Dupree",
        Name: "Bevelry",
        Dependant: "",
        Street: "13708 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 633,
        "Primary Phone": "818-833-1648",
        "Secondary Phone": "",
        "Primary Email": "belainedupree@aol.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0007",
        "Last Name": "Brix",
        Name: "Robert",
        Dependant: "",
        Street: "13698 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 648,
        "Primary Phone": "818-268-9314",
        "Secondary Phone": "",
        "Primary Email": "bobebrix@msn.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0008",
        "Last Name": "Ascencio",
        Name: "Abraham",
        Dependant: "",
        Street: "13692 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 371,
        "Primary Phone": "818-564-8864",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0008",
        "Last Name": "Puentes",
        Name: "Maria de Jesus",
        Dependant: "",
        Street: "13692 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 371,
        "Primary Phone": "818-472-1723",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0009",
        "Last Name": "Baca",
        Name: "Karen",
        Dependant: "",
        Street: "13693 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 426,
        "Primary Phone": "747-322-2358",
        "Secondary Phone": "",
        "Primary Email": "karenbaca1@yahoo.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0009",
        "Last Name": "Baca",
        Name: "Julio",
        Dependant: "",
        Street: "13693 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 426,
        "Primary Phone": "747-322-2357",
        "Secondary Phone": "",
        "Primary Email": "sweepingrage@hotmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0010",
        "Last Name": "Besharaty",
        Name: "Kelly",
        Dependant: "",
        Street: "13695 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 622,
        "Primary Phone": "818-364-0889",
        "Secondary Phone": "818-554-4116",
        "Primary Email": "kellystenson69@gmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0011",
        "Last Name": "Brown",
        Name: "Carol",
        Dependant: "",
        Street: "13699 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 527,
        "Primary Phone": "818-356-1656",
        "Secondary Phone": "818-269-5526",
        "Primary Email": "carolbrown6@ca.rr.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0012",
        "Last Name": "Contreras",
        Name: "Jose",
        Dependant: "",
        Street: "13701 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 425,
        "Primary Phone": "818-516-1520",
        "Secondary Phone": "818-802-2884",
        "Primary Email": "allaboutwood47@yahoo.com",
        "Secondary Email": "cm0417@yahoo.com"
      },
      {
        "File No.": "53000-0012",
        "Last Name": "Contreras",
        Name: "Erika",
        Dependant: "Minor",
        Street: "13701 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 425,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0012",
        "Last Name": "Contreras",
        Name: "Luis Angel",
        Dependant: "Minor",
        Street: "13701 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 425,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0012",
        "Last Name": "Montenegro",
        Name: "Claudia",
        Dependant: "",
        Street: "13739 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 425,
        "Primary Phone": "818-802-2884",
        "Secondary Phone": "",
        "Primary Email": "cm0417@yahoo.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0013",
        "Last Name": "Cortez",
        Name: "Olivia",
        Dependant: "",
        Street: "13691 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 530,
        "Primary Phone": "818-626-0107",
        "Secondary Phone": "",
        "Primary Email": "carmencortz@gmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0013",
        "Last Name": "Cortez",
        Name: "Carmen",
        Dependant: "",
        Street: "13691 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 530,
        "Primary Phone": "818-399-8673",
        "Secondary Phone": "",
        "Primary Email": "carmentcortez1@yahoo.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0013",
        "Last Name": "Elizarraras",
        Name: "Ashley",
        Dependant: "Minor",
        Street: "13691 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 530,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0013",
        "Last Name": "Elizarraras",
        Name: "Jasmine",
        Dependant: "Minor",
        Street: "13691 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 530,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0014",
        "Last Name": "Cromar",
        Name: "Kimberly",
        Dependant: "",
        Street: "13703 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 428,
        "Primary Phone": "818-367-3272",
        "Secondary Phone": "",
        "Primary Email": "kjcromarusc@gmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0014",
        "Last Name": "Guerrero",
        Name: "Olivia",
        Dependant: "",
        Street: "13703 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 428,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0015",
        "Last Name": "Cross",
        Name: "Harriett",
        Dependant: "",
        Street: "13704 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 477,
        "Primary Phone": "818-825-0216",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0016",
        "Last Name": "Dadras",
        Name: "John",
        Dependant: "",
        Street: "13704 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 629,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "v8john@peoplepc.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0017",
        "Last Name": "Davis",
        Name: "Sandra",
        Dependant: "",
        Street: "13705 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 417,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "sdavis32@ca.rr.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0018",
        "Last Name": "Duarte",
        Name: "Raymond Richard",
        Dependant: "",
        Street: "13707 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 453,
        "Primary Phone": "818-306-0557",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0018",
        "Last Name": "Duarte",
        Name: "Christine",
        Dependant: "",
        Street: "13707 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 453,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "chrissyduarte2012@hotmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0019",
        "Last Name": "Duran",
        Name: "David",
        Dependant: "",
        Street: "13709 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 498,
        "Primary Phone": "818-675-0579",
        "Secondary Phone": "",
        "Primary Email": "ivy.duran@ymail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0019",
        "Last Name": "Duran",
        Name: "Jessica",
        Dependant: "",
        Street: "13709 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 498,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0019",
        "Last Name": "Duran",
        Name: "Nicole",
        Dependant: "Minor",
        Street: "13709 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 498,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0019",
        "Last Name": "Duran",
        Name: "Julie",
        Dependant: "",
        Street: "13709 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 498,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0019",
        "Last Name": "Duran",
        Name: "Andrew",
        Dependant: "Minor",
        Street: "13709 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 498,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0020",
        "Last Name": "Cereh",
        Name: "Sandra",
        Dependant: "",
        Street: "13710 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 516,
        "Primary Phone": "818-272-9399",
        "Secondary Phone": "cerehsandra29@yahoo.com",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0020",
        "Last Name": "Cereh",
        Name: "Breann",
        Dependant: "",
        Street: "13710 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 516,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0020",
        "Last Name": "Ellis",
        Name: "Isabella",
        Dependant: "",
        Street: "13710 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 516,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0020",
        "Last Name": "Ellis",
        Name: "Kyla",
        Dependant: "",
        Street: "13710 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 516,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0020",
        "Last Name": "Ellis",
        Name: "Sasha",
        Dependant: "",
        Street: "13710 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 516,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0020",
        "Last Name": "Ellis",
        Name: "Dorian",
        Dependant: "",
        Street: "13710 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 516,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0021",
        "Last Name": "Fera",
        Name: "Linda",
        Dependant: "",
        Street: "13712 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 517,
        "Primary Phone": "",
        "Secondary Phone": "lindafera@yahoo.com",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0021",
        "Last Name": "Fera",
        Name: "Mary",
        Dependant: "",
        Street: "13712 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 517,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0022",
        "Last Name": "Fontenette",
        Name: "Lynn",
        Dependant: "",
        Street: "13713 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 601,
        "Primary Phone": "",
        "Secondary Phone": "thefontenette@aol.com",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0022",
        "Last Name": "de Jesus",
        Name: "Denise",
        Dependant: "",
        Street: "13713 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 601,
        "Primary Phone": "818-433-8566",
        "Secondary Phone": "",
        "Primary Email": "deniedj1999@gmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0023",
        "Last Name": "Ganajian",
        Name: "Haig",
        Dependant: "",
        Street: "13715 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 510,
        "Primary Phone": "818-362-5246",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0023",
        "Last Name": "Hicks",
        Name: "Linda",
        Dependant: "",
        Street: "13715 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 510,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "LLH@ca.rr.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0024",
        "Last Name": "Garcia",
        Name: "Luisa",
        Dependant: "",
        Street: "13716 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 434,
        "Primary Phone": "818-257-5531",
        "Secondary Phone": "818-362-0117",
        "Primary Email": "mrs.luisa31@gmail.com",
        "Secondary Email": "schlgargia@aol.com"
      },
      {
        "File No.": "53000-0024",
        "Last Name": "Garcia",
        Name: "Cecilia",
        Dependant: "",
        Street: "",
        City: "",
        State: "",
        Zipcode: "",
        "Space #": "",
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0024",
        "Last Name": "Garcia",
        Name: "Nicolas",
        Dependant: "",
        Street: "13717 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 349,
        "Primary Phone": "818-512-4088",
        "Secondary Phone": "",
        "Primary Email": "nicolas.garcia@roadrunner.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0025",
        "Last Name": "Gotelip",
        Name: "Sebastian",
        Dependant: "",
        Street: "13720 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 402,
        "Primary Phone": "818-822-2779",
        "Secondary Phone": "",
        "Primary Email": "sgotelip@mac.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0025",
        "Last Name": "Gotelip",
        Name: "Iara",
        Dependant: "",
        Street: "13720 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 402,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0025",
        "Last Name": "Gotelip",
        Name: "Sasha",
        Dependant: "",
        Street: "13720 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 402,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0025",
        "Last Name": "Gotelip",
        Name: "Bryan",
        Dependant: "",
        Street: "13720 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 402,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0026",
        "Last Name": "Graves",
        Name: "Sheri",
        Dependant: "",
        Street: "13721 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 467,
        "Primary Phone": "818-335-2128",
        "Secondary Phone": "",
        "Primary Email": "sherilynnpooh@yahoo.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0026",
        "Last Name": "Graves",
        Name: "Bud",
        Dependant: "",
        Street: "13721 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 467,
        "Primary Phone": "818-335-2130",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0027",
        "Last Name": "Jackson",
        Name: "Jeannine",
        Dependant: "",
        Street: "13725 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 508,
        "Primary Phone": "818-939-7696",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0028",
        "Last Name": "Jensen",
        Name: "Brian",
        Dependant: "",
        Street: "13726 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 622,
        "Primary Phone": "818-364-0889",
        "Secondary Phone": "",
        "Primary Email": "brobee69@yahoo.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0029",
        "Last Name": "Johnson",
        Name: "Sylvia",
        Dependant: "",
        Street: "13727 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 437,
        "Primary Phone": "818-364-2288",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0030",
        "Last Name": "Lamy",
        Name: "Gina",
        Dependant: "",
        Street: "13732 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 429,
        "Primary Phone": "818-364-9194",
        "Secondary Phone": "",
        "Primary Email": "gina33R@yahoo.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0030",
        "Last Name": "Lamy",
        Name: "Rudy",
        Dependant: "",
        Street: "13732 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 429,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0031",
        "Last Name": "Basulto",
        Name: "Jessica",
        Dependant: "",
        Street: "13732 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 429,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0031",
        "Last Name": "Codel",
        Name: "Tristan",
        Dependant: "",
        Street: "13732 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 429,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0031",
        "Last Name": "Codel",
        Name: "Xavier",
        Dependant: "",
        Street: "13732 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 429,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0031",
        "Last Name": "Gonzalez",
        Name: "Angelisa",
        Dependant: "",
        Street: "13732 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 429,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0031",
        "Last Name": "Marcano",
        Name: "Carmen",
        Dependant: "",
        Street: "13732 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 429,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0032",
        "Last Name": "McCulloch",
        Name: "Annette",
        Dependant: "",
        Street: "13736 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 466,
        "Primary Phone": "818-367-6064",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0033",
        "Last Name": "Mendoza",
        Name: "Jose",
        Dependant: "",
        Street: "13738 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 642,
        "Primary Phone": "818-939-9115",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0034",
        "Last Name": "Mendez",
        Name: "Jesus",
        Dependant: "",
        Street: "13740 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 558,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0034",
        "Last Name": "Montes",
        Name: "Gabriela",
        Dependant: "",
        Street: "13740 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 558,
        "Primary Phone": "818-799-8504",
        "Secondary Phone": "818-365-5481",
        "Primary Email": "gab.montes1103@gmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0034",
        "Last Name": "Montes",
        Name: "Christina",
        Dependant: "",
        Street: "13740 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 558,
        "Primary Phone": "818-799-8504",
        "Secondary Phone": "818-365-5481",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0034",
        "Last Name": "Preciado",
        Name: "Rafael",
        Dependant: "",
        Street: "13740 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 558,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0034",
        "Last Name": "Rojas",
        Name: "Jacob",
        Dependant: "Minors",
        Street: "13740 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 558,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0034",
        "Last Name": "Rojas",
        Name: "Arleth",
        Dependant: "Minors",
        Street: "13740 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 558,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0035",
        "Last Name": "Moscicki",
        Name: "Walter",
        Dependant: "",
        Street: "13741 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 511,
        "Primary Phone": "818-400-7774",
        "Secondary Phone": "747-246-4162",
        "Primary Email": "wmoscic1398@earthlink.net",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0036",
        "Last Name": "Papp",
        Name: "Paul",
        Dependant: "",
        Street: "13745 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 525,
        "Primary Phone": "818-362-4608",
        "Secondary Phone": "",
        "Primary Email": "pmpapp1066@aol.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0036",
        "Last Name": "Papp",
        Name: "Colleen",
        Dependant: "",
        Street: "13745 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 525,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0037",
        "Last Name": "Plaencia",
        Name: "Victoria",
        Dependant: "",
        Street: "13729 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 436,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0038",
        "Last Name": "Ramirez",
        Name: "Karina",
        Dependant: "",
        Street: "13691 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 613,
        "Primary Phone": "818-378-1345",
        "Secondary Phone": "",
        "Primary Email": "Karina052578@gmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0038",
        "Last Name": "Ramirez",
        Name: "Daniel",
        Dependant: "",
        Street: "13691 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 613,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0038",
        "Last Name": "Ramirez",
        Name: "Karen",
        Dependant: "",
        Street: "13691 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 613,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0039",
        "Last Name": "Rowland",
        Name: "Lisa",
        Dependant: "",
        Street: "13749 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 563,
        "Primary Phone": "626-864-5046",
        "Secondary Phone": "818-639-0435",
        "Primary Email": "tanzie11@gmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0040",
        "Last Name": "Samuels",
        Name: "Ranon",
        Dependant: "",
        Street: "13750 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 459,
        "Primary Phone": "818-364-8506",
        "Secondary Phone": "",
        "Primary Email": "rsdiva@msn.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0040",
        "Last Name": "Samuels",
        Name: "Rhoda",
        Dependant: "",
        Street: "13750 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 459,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0041",
        "Last Name": "Martinez",
        Name: "Yadira",
        Dependant: "",
        Street: "13752 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 639,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0041",
        "Last Name": "Sandoval",
        Name: "Luis",
        Dependant: "",
        Street: "13752 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 639,
        "Primary Phone": "818-426-1764",
        "Secondary Phone": "",
        "Primary Email": "yadissalon@yahoo.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0042",
        "Last Name": "Steed",
        Name: "Alfred",
        Dependant: "",
        Street: "13755 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 500,
        "Primary Phone": "818-833-3010",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0042",
        "Last Name": "Steed",
        Name: "Rina",
        Dependant: "",
        Street: "13755 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 500,
        "Primary Phone": "818-833-3010",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0043",
        "Last Name": "Vassar",
        Name: "Doug",
        Dependant: "",
        Street: "13759 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 363,
        "Primary Phone": "310-384-6048",
        "Secondary Phone": "",
        "Primary Email": "kissy145@hotmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0043",
        "Last Name": "Vassar",
        Name: "Anna",
        Dependant: "",
        Street: "13759 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 363,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0044",
        "Last Name": "Velasquez",
        Name: "Rudy",
        Dependant: "",
        Street: "13760 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 392,
        "Primary Phone": "661-877-1990",
        "Secondary Phone": "",
        "Primary Email": "rudyv76@yahoo.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0044",
        "Last Name": "Velasquez",
        Name: "Jessica",
        Dependant: "Minor",
        Street: "13760 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 392,
        "Primary Phone": "661-877-1990",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0044",
        "Last Name": "Velasquez",
        Name: "Rudy Jr.",
        Dependant: "Minor",
        Street: "13760 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 392,
        "Primary Phone": "661-877-1990",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0045",
        "Last Name": "Velez-cal",
        Name: "Maria del Carmen",
        Dependant: "",
        Street: "13761 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 468,
        "Primary Phone": "818-390-4849",
        "Secondary Phone": "",
        "Primary Email": "chicavallartas@yahoo.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0046",
        "Last Name": "Villarreal",
        Name: "Jose",
        Dependant: "",
        Street: "13761 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 374,
        "Primary Phone": "818-364-8574",
        "Secondary Phone": "",
        "Primary Email": "arlvilla1216@yahoo.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0046",
        "Last Name": "Villarreal",
        Name: "Omar",
        Dependant: "",
        Street: "13761 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 374,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0047",
        "Last Name": "Webster",
        Name: "Martell",
        Dependant: "",
        Street: "13763 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 512,
        "Primary Phone": "313-740-7429",
        "Secondary Phone": "",
        "Primary Email": "pwebster5354@att.net",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0047",
        "Last Name": "Webster",
        Name: "Priscilla",
        Dependant: "",
        Street: "13763 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 512,
        "Primary Phone": "313-740-7429",
        "Secondary Phone": "",
        "Primary Email": "",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0048",
        "Last Name": "White",
        Name: "Rodney",
        Dependant: "",
        Street: "13764 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 398,
        "Primary Phone": "818-517-4221",
        "Secondary Phone": "",
        "Primary Email": "rodwhite1937@gmail.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0049",
        "Last Name": "Wilkins",
        Name: "Pat",
        Dependant: "",
        Street: "13765 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 600,
        "Primary Phone": "818-694-8113",
        "Secondary Phone": "",
        "Primary Email": "pat@wilkinsguitars.com",
        "Secondary Email": ""
      },
      {
        "File No.": "53000-0049",
        "Last Name": "Wilkins",
        Name: "Maria",
        Dependant: "",
        Street: "13765 Gavina Ave.",
        City: "Sylmar",
        State: "CA",
        Zipcode: 91342,
        "Space #": 600,
        "Primary Phone": "",
        "Secondary Phone": "",
        "Primary Email": "marialw60@yahoo.com",
        "Secondary Email": ""
      }
    ]
  }),
  methods: {
    async addBulk() {
      this.users.forEach(user => {
        if (user.Street) {
          //set up matter
          // console.log(user["File No."]);
          let alias =
            user["File No."] +
            " " +
            "Creek Fire" +
            " " +
            user.Street +
            " " +
            user["Space #"];
          let matterSlug = slugify(alias, {
            replacement: "-",
            remove: /[$*_+~.()'"!\-:@,]/g,
            lower: true
          });

          const newMatter = {
            // dateOfLoss: this.formattedDateOfLoss,

            data: {
              caseName: alias,
              caseNumber: "18STCV03092",
              dateOfLoss: "12/05/2017",
              statuteOfLimitations: `12/05/2019`,
              complaintDeadline: null,
              dateOfComplaint: null,
              internalID: user["File No."],
              causesOfAction: ["NEGLIGENCE"],
              coordinationProceeding: true,
              specialTitle: "CREEK FIRE CASES (JCCP NO. 4965)",
              status: "steady",
              dateCreated: moment().format("MMMM Do YYYY, h:mm:ss a"),
              creatorID: this.$store.getters.user.email,
              notes: [],
              activities: [],
              attorneys: [
                {
                  barNumber: "57550",
                  fullName: "Walter J. Lack, SBN 57550",
                  name: "Walter J. Lack"
                },
                {
                  barNumber: "241782",
                  fullName: "Gregory P. Waters, SBN 241782",
                  name: "Gregory P. Waters"
                }
              ],
              matterSlug: matterSlug,
              jdxState: "CA",
              jdxCounty: "Los Angeles",
              jdxCourtHouseName: "Spring Street Courthouse",
              jdxCourtHouseStreetAddressLine1: "111 Spring St.",
              jdxCourtHouseCity: "Los Angeles",
              jdxCourtHouseState: "CA",
              jdxCourtHouseZip: "90012",
              jdxDepartment: "001",
              jdxJudge: "Hon. Daniel J. Buckley",
              caseDocs: {
                initialDocs: []
              },
              plaintiffs: [],
              defendants: [
                {
                  addressLine1: null,
                  attorney: null,
                  cityStateZip: null,
                  dateOfBirth: null,
                  email: null,
                  fullName: "Southern California Edison",
                  insurance: null,
                  phone: null,
                  type: "business"
                }
              ],
              sharedWith: ["nrajamand@elllaw.com", "vghica@elllaw.com"],
              firms: [
                {
                  firmAddressLine: "10100 Santa Monica Blvd. 12th Floor",
                  firmCityStateZip: "Los Angeles, CA 90067",
                  firmFax: "(310) 552-9434",
                  firmName: "Engstrom, Lipscomb & Lack",
                  firmPhone: "(310) 552-3800",
                  firmSlug: "engstrom-lipscomb-and-lack",
                  userList: [
                    "nrajamand@elllaw.com",
                    "vghica@elllaw.com",
                    "user7@email.com",
                    "temp@email.com",
                    "findingnima1@gmail.com",
                    "dcwhalen@elllaw.com",
                    "jplaza@elllaw.com",
                    "agutierrez@elllaw.com",
                    "test2@email.com"
                  ]
                }
              ],
              events: [],
              trialDate: null
            },
            firmSlug: this.$store.getters.user.firmSlug

            // initialDocs: this.initialDocs
          };

          console.log("newMatter", newMatter);
          let plaintiffPhone = "";
          if (user["Primary Phone"]) {
            plaintiffPhone = user["Primary Phone"];
          } else {
            let pass = Math.floor(100000 + Math.random() * 900000);
            plaintiffPhone = pass.toString();
          }
          let fullName = user["Name"].trim() + " " + user["Last Name"].trim();
          let plaintiffAlias = fullName + " " + plaintiffPhone;
          let partySlug = slugify(plaintiffAlias, {
            replacement: "-",
            remove: /[$*_+~.()'"!\-:@,]/g,
            lower: true
          });
          let emailSlug = slugify(plaintiffAlias, {
            replacement: "_",
            remove: /[$*_+~.()'"!\-:@,]/g,
            lower: true
          });

          let plaintiffEmail = "";

          if (user["Primary Email"]) {
            plaintiffEmail = user["Primary Email"];
          } else {
            plaintiffEmail = `${emailSlug}@taplaw.com`;
          }
          let partyType = "individual";
          if (user["Dependant"] == "Minor") {
            partyType = "minor";
          }
          const payload = {
            plaintiff: {
              firstName: user["Name"],
              lastName: user["Last Name"],
              fullName: fullName,
              addressLine1: `${user["Street"]}, #${user["Space #"]}`,
              cityStateZip: `${user["City"]}, ${user["CA"]} ${user["Zipcode"]}`,
              phone: plaintiffPhone,
              email: plaintiffEmail,
              attorney: null,
              dateOfBirth: null,
              type: "individual",
              //experimental
              formList: [],
              insurance: [],
              partySlug
            },
            firmSlug: this.$store.getters.user.firmSlug,
            matterSlug: matterSlug,
            activity: {
              content: `${this.$store.getters.user.email} added a new plaintiff to ${alias}, named ${fullName}.`,
              matterID: matterSlug,
              date: moment().format("MMMM Do YYYY, h:mm:ss a"),
              user: this.$store.getters.user.email
            }
          };

          console.log("new plaintiff", payload);
          //see if matter exists
          console.log("checking for matter in DB");
          //I had to comment this out to redo the run because individuals
          //that didnt have an email were not getting added to the auth
          //find matter
          firebase
            .firestore()
            .collection("matters")
            .doc(matterSlug)
            .get()
            .then(doc => {
              //if matter exists
              if (doc.exists) {
                console.log("matter exists");
                //get clients collection
                firebase
                  .firestore()
                  .collection("matters")
                  .doc(matterSlug)
                  .collection("clients")
                  .get()
                  .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                      //delete each client document from collection
                      // doc.data() is never undefined for query doc snapshots
                      console.log(doc.id, " => ", doc.data());
                      firebase
                        .firestore()
                        .collection("matters")
                        .doc(matterSlug)
                        .collection("clients")
                        .doc(doc.id)
                        .delete();
                    });
                  })
                  .then(() => {
                    //delete the matter
                    firebase
                      .firestore()
                      .collection("matters")
                      .doc(matterSlug)
                      .delete();
                  })
                  .then(() => {
                    console.log("matter deleted");
                    this.$store.dispatch("createMatter", newMatter);

                    //add plaintiff with the "addPlaintiff()" function (see store)
                    console.log("dispatching addPlaintiff mutation");
                    this.$store.dispatch("addPlaintiff", payload);
                    console.log(
                      "adding clinet role to user with addClient role cloud function"
                    );
                    firebase
                      .app()
                      .functions()
                      .useFunctionsEmulator("http://localhost:5001");

                    const addClientRole = firebase
                      .functions()
                      .httpsCallable("addClientRole");
                    addClientRole({
                      email: plaintiffEmail,
                      password: payload.plaintiff.phone,
                      firmSlug: payload.firmSlug,
                      matterSlug: matterSlug,
                      partySlug: payload.plaintiff.partySlug,
                      partyType
                    }).catch(e => {
                      console.error(e.message);
                    });
                  });
              }
            });
          //   console.log("dispatching addPlaintiff mutation");
          //   //if yes
          //   //add plaintiff object and add to matter with the "addPlaintiff()" function (see store)
          //   this.$store.dispatch("addPlaintiff", payload);
          //   console.log(
          //     "adding clinet role to user with addClient role cloud function"
          //   );
          //   const addClientRole = firebase
          //     .functions()
          //     .httpsCallable("addClientRole");
          //   addClientRole({
          //     email: plaintiffEmail,
          //     password: plaintiffPhone,
          //     firmSlug: payload.firmSlug,
          //     matterSlug: matterSlug,
          //     partySlug: payload.plaintiff.partySlug,
          //     partyType: "individual"
          //   });
          // } else {
          //if no
          //create matter (see "createMatter()" funciton in store)
          // console.log("matter DOES NOT exist - dispatching createMatter");
          // this.$store.dispatch("createMatter", newMatter);

          // //add plaintiff with the "addPlaintiff()" function (see store)
          // console.log("dispatching addPlaintiff mutation");
          // this.$store.dispatch("addPlaintiff", payload);
          // console.log(
          //   "adding clinet role to user with addClient role cloud function"
          // );
          // firebase
          //   .app()
          //   .functions()
          //   .useFunctionsEmulator("http://localhost:5001");

          // const addClientRole = firebase
          //   .functions()
          //   .httpsCallable("addClientRole");
          // addClientRole({
          //   email: plaintiffEmail,
          //   password: payload.plaintiff.phone,
          //   firmSlug: payload.firmSlug,
          //   matterSlug: matterSlug,
          //   partySlug: payload.plaintiff.partySlug,
          //   partyType
          // }).catch(e => {
          //   console.error(e.message);
          // });
          // }
          // });

          //   {
          //   "File No.": "53000-0002",
          //   "Last Name": "Bresnan",
          //   Name: "Jerry",
          //   Dependant: "",
          //   Street: "13697 Gavina Ave.",
          //   City: "Sylmar",
          //   State: "CA",
          //   Zipcode: 91342,
          //   "Space #": 640,
          //   "Primary Phone": "818-336-6927",
          //   "Secondary Phone": "760-685-1314",
          //   "Primary Email": "jerryb334@aol.com",
          //   "Secondary Email": ""
          // },

          // let plaintiff = {
          //   firstName: this.firstName,
          //   lastName: this.lastName,
          //   fullName: this.fullName,
          //   addressLine1: this.addressLine1,
          //   cityStateZip: this.cityStateZip,
          //   phone: this.phone,
          //   email: this.email,
          //   attorney: this.attorney,
          //   dateOfBirth: this.dateOfBirth,
          //   type: this.type,
          //   //experimental
          //   formList: null,
          //   insurance: [],
          //   partySlug,
          // }
        } else {
          console.log("No Street for user: ", user);
        }
      });
    }
  }
};
</script>
